<template>
  <div class="cardWrap">
    <div class="cardTitle" v-if="title">{{title}}</div>
    <slot name="title" />
    <div class="cardContent mt5">
      <slot></slot>
    </div>
  </div>
</template>
<script>
export default {
  name: 'cardWrap',
  props: {
    title: {
      type: String,
      default: ''
    }
  },
  data() {
    return {}
  }
}
</script>
<style scoped>
.cardWrap {
  background: #fff;
  border-radius: 10px;
  padding: 18px 13px 10px;
}
.cardTitle {
  padding-left: 10px;
  font-size: 20px;
  font-weight: 500;
  color: var(--font-color);
  line-height: 30px;
  position: relative;
}
.cardTitle::before {
  position: absolute;
  content: "";
  top: 50%;
  left: 0;
  width: 4px;
  height: 15px;
  background: #c1121e;
  border-radius: 2px;
  transform: translateY(-50%);
}
.flexBox {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  font-size: 15px;
}
.left {
  font-weight: 400;
  color: #999999;
}
.right {
  flex: 1;
  text-align: right;
  color: #333333;
}
.van-cell {
  padding: 10px 0;
}
.van-cell::after {
  left: 0;
  right: 0;
}
</style>